<script>

    import { PickupStore } from '../stores'

    import DateMethods from '../$methods/date.methods'
    import EnumMethods from '../$methods/enum.methods'

    import Value from '../$components/value.svelte'

</script>

{#if $PickupStore}
    <div class="columns">
        <div class="column">
            <Value label="Guía" value={ $PickupStore.guide} />
        </div>
        <div class="column">
            <Value label="Estatus" value={ EnumMethods.get($PickupStore.status)} />
        </div>
    </div>
    <hr>
    <div class="columns">
        <div class="column">
            <Value label="Contacto" value={ $PickupStore.location.contact } />
        </div>
        <div class="column">
            <Value label="Empresa" value={ $PickupStore.location.company || '' } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="RFC" value={ $PickupStore.location.rfc } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Teléfono" value={ $PickupStore.location.phone } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Correo electrónico" value={ $PickupStore.location.email } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="C.P" value={ $PickupStore.location.zipcode } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Estado" value={ $PickupStore.location.state } />
        </div>
        <div class="column">
            <Value label="Ciudad" value={ $PickupStore.location.city } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Municipio" value={ $PickupStore.location.municipality } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Colonia" value={ $PickupStore.location.colony } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Calle" value={ $PickupStore.location.street } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Número exterior" value={ $PickupStore.location.number } />
        </div>
        <div class="column">
            <Value label="Número interior" value={ $PickupStore.location.apartment || 'Sin información' } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Referencias" value={ $PickupStore.location.references } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Entre calles" value={ $PickupStore.location.betweenStreets } />
        </div>
    </div>
    <hr>
    <div class="columns">
        <div class="column">
            <Value label="Ancho" value={ $PickupStore.package.width } postfix="CM" />
        </div>
        <div class="column">
            <Value label="Alto" value={ $PickupStore.package.height } postfix="CM" />
        </div>
        <div class="column">
            <Value label="Largo" value={ $PickupStore.package.length } postfix="CM" />
        </div>
        <div class="column">
            <Value label="Peso" value={ $PickupStore.package.weight } postfix="KG" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Contenido del paquete" value={ $PickupStore.package.content } />
        </div>
        <div class="column">
            <Value label="Total de paquetes" value={ $PickupStore.package.total } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Notas importantes" value={ $PickupStore.notes } />
        </div>
    </div>
    <hr>
    <div class="columns">
        <div class="column">
            <Value label="Fecha de registro" value={ DateMethods.dateLarge($PickupStore.created) } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Fecha de recolección" value={ DateMethods.dateLarge($PickupStore.date) } />
        </div>
    </div>
{/if}